'use strict';

var resources = angular.module('resources', ['ngResource', 'config']);

resources.factory('AppointmentResource', function($resource, ClinicConfig) {
  return $resource(ClinicConfig.HOSTNAME + '/clinic/appointment/:id');
});

resources.factory('AppointmentsResource', function($resource, ClinicConfig) {
  return $resource(ClinicConfig.HOSTNAME + '/clinic/appointment/');
});

resources.factory('AppointmentStateResource', function($resource, ClinicConfig) {
  return $resource(ClinicConfig.HOSTNAME + '/clinic/appointment/:id/:action', {}, {
    cancel: {
      method: 'POST',
      params: {
        id: '@id',
        action: 'cancel',
      },
    },
    getSlotWorks: {
      method: 'GET',
      params: {
        id: '@id',
        action: 'slotWorks',
      },
    },
    update: {
      method: 'POST',
      params: {
        id: '@id',
        action: 'update',
      },
    },
    note: {
      method: 'POST',
      params: {
        id: '@id',
        action: 'note',
      },
    },
    archive: {
      method: 'POST',
      params: {
        id: '@id',
        action: 'archive',
      },
    },
    message: {
      method: 'POST',
      params: {
        id: '@id',
        action: 'message',
      },
    },
    viewed: {
      method: 'PUT',
      params: {
        id: '@id',
        action: 'viewed',
      },
    },
    getHistory: {
      method: 'GET',
      params: {
        id: '@id',
        action: 'history',
      },
      isArray: true,
    },
    billingContested: {
      method: 'PUT',
      params: {
        id: '@id',
        action: 'billingContested',
      },
    },
    defer: {
      method: 'PUT',
      params: {
        id: '@id',
        action: 'defer',
      },
    },
  });
});

resources.factory('ClaimClinicResource', function($resource, ClinicConfig) {
  return $resource(ClinicConfig.HOSTNAME + '/company/:id/clinic/:clinicId/claim');
});

resources.factory('ClinicResource', function($resource, ClinicConfig) {
  return $resource(ClinicConfig.HOSTNAME + '/clinic/:id/:action', {}, {
    update: {
      method: 'PUT',
      params: {
        id: '@id',
      },
    },
  });
});

resources.factory('ClinicOCSResource', function($resource, ClinicConfig) {
  return $resource(ClinicConfig.HOSTNAME + '/clinic/:id/status/', {}, {
    get: {
      method: 'GET',
      params: {
        id: '@id',
      },
    },
  });
});

resources.factory('ClinicFeatureResource', function($resource, ClinicConfig) {
  return $resource(ClinicConfig.HOSTNAME + '/clinic/:id/features/', {}, {
    update: {
      method: 'PUT',
      params: {
        id: '@id',
      },
    },
  });
});

resources.factory('ClinicSearchResource', function($resource, ClinicConfig) {
  return $resource(ClinicConfig.HOSTNAME + '/clinic/');
});

resources.factory('ClinicDoctorsResource', function($resource, ClinicConfig) {
  return $resource(ClinicConfig.HOSTNAME + '/clinic/:id/doctor/:doctorId');
});

resources.factory('ClinicDoctorsResource', function($resource, ClinicConfig) {
  return $resource(ClinicConfig.HOSTNAME + '/clinic/:id/doctor/:doctorId');
});

resources.factory('CompanyClinicResource', function($resource, ClinicConfig) {
  return $resource(ClinicConfig.HOSTNAME + '/company/:id/clinic/');
});

resources.factory('DoctorResource', function($resource, ClinicConfig) {
  return $resource(ClinicConfig.HOSTNAME + '/doctor/:id/:action', {}, {
    update: {
      method: 'PUT',
      params: {
        id: '@id',
      },
    },
  });
});

resources.factory('DoctorSearchResource', function($resource, ClinicConfig) {
  return $resource(ClinicConfig.HOSTNAME + '/doctor/search');
});

resources.factory('IsAuthenticatedResource', function($resource, ClinicConfig) {
  return $resource(ClinicConfig.HOSTNAME + '/isAuthenticated');
});

resources.factory('InsuranceProviderResource', function($resource, ClinicConfig) {
  return $resource(ClinicConfig.HOSTNAME + '/insuranceprovider/:id');
});

resources.factory('LanguageResource', function($resource, ClinicConfig) {
  return $resource(ClinicConfig.HOSTNAME + '/language?:options', {
    options: '',
  });
});

resources.factory('LoginResource', function($resource, ClinicConfig) {
  return $resource(ClinicConfig.HOSTNAME + '/login');
});

resources.factory('LogoutResource', function($resource, ClinicConfig) {
  return $resource(ClinicConfig.HOSTNAME + '/logout');
});

resources.factory('NewPasswordResource', function($resource, ClinicConfig) {
  return $resource(ClinicConfig.HOSTNAME + '/user/updatePassword', {}, {
    update: {
      method: 'PUT',
    },
  });
});

resources.factory('PermissionResource', function($resource, ClinicConfig) {
  return $resource(ClinicConfig.HOSTNAME + '/:modelType/:id/permission/:userId', {}, {
    delete: {
      method: 'DELETE',
    },
  });
});

resources.factory('PermissionMetadataResource', function($resource, ClinicConfig) {
  return $resource(ClinicConfig.HOSTNAME + '/:modelType/:id/permission/:userId', {}, {
    update: {
      method: 'PUT',
      params: {
        id: '@id',
      },
    },
  });
});

resources.factory('ProviderOfferedAppointmentTypeResource', function($resource, ClinicConfig) {
  return $resource(ClinicConfig.HOSTNAME + '/provider/:id/offeredAppointmentType/:offeredAppointmentTypeId');
});

resources.factory('ProviderOfferedServiceResource', function($resource, ClinicConfig) {
  return $resource(ClinicConfig.HOSTNAME + '/provider/:id/offeredService/:offeredServiceId');
});

resources.factory('ProviderResource', function($resource, ClinicConfig) {
  return $resource(ClinicConfig.HOSTNAME + '/provider/:id', {}, {
    update: {
      method: 'PUT',
      params: {
        id: '@id',
      },
    },
  });
});

resources.factory('ProviderConfirmRelationshipResource', function($resource, ClinicConfig) {
  return $resource(ClinicConfig.HOSTNAME + '/provider/:providerId/confirmRelationship/:id');
});

resources.factory('RequestPhoneVerificationResource', function($resource, ClinicConfig) {
  return $resource(ClinicConfig.HOSTNAME + '/clinic/:id/requestPhoneVerification', {
    id: '@id',
  });
});

resources.factory('RequestResetPasswordResource', function($resource, ClinicConfig) {
  return $resource(ClinicConfig.HOSTNAME + '/user/requestResetPassword');
});

resources.factory('SignupResource', function($resource, ClinicConfig) {
  return $resource(ClinicConfig.HOSTNAME + '/signup');
});

resources.factory('SubmitResetPasswordResource', function($resource, ClinicConfig) {
  return $resource(ClinicConfig.HOSTNAME + '/user/submitResetPassword');
});

resources.factory('SendEmailAddressVerificationResource', function($resource, ClinicConfig) {
  return $resource(ClinicConfig.HOSTNAME + '/verify/sendEmail');
});

resources.factory('AppointmentTypeResource', function($resource, ClinicConfig) {
  return $resource(ClinicConfig.HOSTNAME + '/appointmentType?:options', {
    options: '',
  });
});

resources.factory('SpecialtyResource', function($resource, ClinicConfig) {
  return $resource(ClinicConfig.HOSTNAME + '/specialty?:options', {
    options: '',
  });
});

resources.factory('FeatureResource', function($resource, ClinicConfig) {
  return $resource(ClinicConfig.HOSTNAME + '/feature');
});

resources.factory('DoctorInsurancePlanResource', function($resource, ClinicConfig) {
  return $resource(ClinicConfig.HOSTNAME + '/doctor/:doctorId/insurance', {}, {
    update: {
      method: 'PUT',
    },
    add: {
      method: 'POST',
    },
    delete: {
      method: 'DELETE',
    },
  });
});

resources.factory('DoctorSpecialtyAddResource', function($resource, ClinicConfig) {
  return $resource(ClinicConfig.HOSTNAME + '/doctor/:doctor/specialty/:id');
});

resources.factory('DoctorSpecialtyRemoveResource', function($resource, ClinicConfig) {
  return $resource(ClinicConfig.HOSTNAME + '/doctor/:doctor/specialty/:id', {}, {
    delete: {
      method: 'DELETE',
    },
  });
});

resources.factory('DoctorLanguageAddResource', function($resource, ClinicConfig) {
  return $resource(ClinicConfig.HOSTNAME + '/doctor/:doctor/language/:id');
});

resources.factory('DoctorLanguageRemoveResource', function($resource, ClinicConfig) {
  return $resource(ClinicConfig.HOSTNAME + '/doctor/:doctor/language/:id', {}, {
    delete: {
      method: 'DELETE',
    },
  });
});

resources.factory('PhotoResource', function($resource, ClinicConfig) {
  return $resource(ClinicConfig.HOSTNAME + '/:modelType/:modelId/photo/:photoName', {}, {
    delete: {
      method: 'DELETE',
    },
    update: {
      method: 'PUT',
    },
  });
});

resources.factory('UserResource', function($resource, ClinicConfig) {
  return $resource(ClinicConfig.HOSTNAME + '/user/:action', {}, {
    update: {
      method: 'PUT',
    },
  });
});

resources.factory('UserPaymentCardResource', function($resource, ClinicConfig) {
  return $resource(ClinicConfig.HOSTNAME + '/user/:id/payment/card/:cardId');
});

resources.factory('UserPaymentInvoiceReportResource', function($resource, ClinicConfig) {
  return $resource(ClinicConfig.HOSTNAME + '/user/:id/payment/card/:cardId/invoiceReport/:year/:month');
});

resources.factory('UserFindInvitationsResource', function($resource, ClinicConfig) {
  return $resource(ClinicConfig.HOSTNAME + '/user/findInvitations');
});

resources.factory('VerifyEmailResource', function($resource, ClinicConfig) {
  return $resource(ClinicConfig.HOSTNAME + '/verify/email');
});

resources.factory('VerifyPhoneResource', function($resource, ClinicConfig) {
  return $resource(ClinicConfig.HOSTNAME + '/verify/phone');
});

resources.factory('QuestionResource', function($resource, ClinicConfig) {
  return $resource(ClinicConfig.HOSTNAME + '/question/:id/:action');
});

resources.factory('VerifyPhoneTokenResource', ['$resource', 'ClinicConfig', function($resource, ClinicConfig) {
  return $resource(ClinicConfig.HOSTNAME + '/verify/token');
}]);

resources.factory('SentimentResource', function($resource, ClinicConfig) {
  return $resource(ClinicConfig.HOSTNAME + '/sentiment/clinic/:clinicId');
});

resources.factory('RescheduledAppointmentSlotsResource', function($resource, ClinicConfig) {
  return $resource(ClinicConfig.HOSTNAME + '/clinic/appointment/:appointmentId/rescheduledAppointmentSlotOptions');
});

resources.factory('UserSignDocumentsResource', function($resource, ClinicConfig) {
  return $resource(ClinicConfig.HOSTNAME + '/user/signDocuments/', {}, {
    update: {
      method: 'PUT',
    },
  });
});
